import { event } from "jquery"
import React from "react"
import {Form,Row,Col} from 'react-bootstrap'


class Datscan extends React.Component{
    constructor(props){
        super(props)
        this.state ={
            abnormalDisabled:true,
            quantificationDisabled:true,
            quantificationMoreDisabled:true,
            data:{
                datscan:"",
                date:"",
                abnormal:"",
                quantification:""
            }
        }
    }
    handleDatscanDate =(event)=>{
        this.props.handler('datscan',event)
    }
    handleDatscan=   (event) =>{
        this.props.handler('datscan',event)
        if(event.target.value =="Yes"){
            this.setState({abnormalDisabled:false})
            
        }
        else{
            this.setState(prevState=>({
                ...prevState,
                abnormalDisabled:true,
                quantificationDisabled:true,
                quantificationMoreDisabled:true,
            }))
           this.props.clean("datscan","date")
           this.props.clean("datscan","abnormal")
           this.props.clean("datscan","quantification")
           this.props.clean("datscan","right_putamen")
           this.props.clean("datscan","left_putamen")
           this.props.clean("datscan","right_caudate_nucleus")
           this.props.clean("datscan","left_caudate_nucleus")
           this.props.clean("datscan","asymmetry_index")



            
        }
        
        
       
        
        // this.props.handler("datscan",event)
    }
    handleAbnormal=  async (event) =>{
        if(event.target.value =="Yes"){
            this.setState({quantificationDisabled:false})
        }
        else{
            this.setState({quantificationDisabled:true})
        }
        this.props.handler('datscan',event)
       
        
    }
    handleQuantification = (event) =>{
        
        if(event.target.value =="Yes"){
            this.setState({quantificationMoreDisabled:false})
        }
        else{
            this.setState({quantificationMoreDisabled:true})
            this.props.clean("datscan","right_putamen")
            this.props.clean("datscan","left_putamen")
            this.props.clean("datscan","right_caudate_nucleus")
            this.props.clean("datscan","left_caudate_nucleus")
            this.props.clean("datscan","asymmetry_index")
            
        }
        this.props.handler('datscan',event)
    }
    
    // shouldComponentUpdate(nextProps,nextState){
    //     if (this.props.data == null){
    //         if(this.state!=nextState ){
            
    //             return true
    //         }
    //         else{
                
    //             return false
    //         }
    //     }
    //     if(this.props.data!=null){
    //         if(nextProps!=this.props || nextState != this.state){
    //             return true
    //         }
    //         else{
    //             return false
    //         }
    //     }
    // }
    componentDidUpdate(prevProps,prevState){
        if(prevState!=this.state&& this.props.data== null){
            this.props.handler("datscan",this.state.data)
        }
        if( prevProps!=this.props){
           
            if(this.props.data['quantification'] == "Yes"){
                
                this.setState((prevState)=>({
                    ...prevState,
                 abnormalDisabled:false,
                 quantificationDisabled:false,
                 quantificationMoreDisabled:false,
 
                }))
            }
            else if(this.props.data['datscan'] == "Yes"){
                
                this.setState((prevState)=>({
                    ...prevState,
                 abnormalDisabled:false,
                 
 
                }))
            }
        }
        
    }
    
    async componentDidMount(){
       
        
    }
    render(){
      
        return(
            <div>
                <Form>
                    <Form.Row>
                        <Form.Group as={Col}>
                            <Form.Label>Datscan</Form.Label>
                            <Form.Control as={'select'}  name={'datscan'} onChange={this.handleDatscan} value={this.props.data['datscan']} disabled={this.props.edit? true:false}>
                                <option></option>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>When</Form.Label>
                            <Form.Control type={'date'}  name={'date'} onChange={this.handleDatscanDate} value={this.props.data['date']} disabled={this.props.edit? true: this.state.abnormalDisabled}/>                          
                            
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Label>Abnormal</Form.Label>
                            <Form.Control as={'select'} name={'abnormal'} value={this.props.data['abnormal']} onChange={this.handleAbnormal} disabled={this.props.edit? true: this.state.abnormalDisabled}>
                                <option></option>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group>
                        
                    </Form.Row>
                    <Form.Row>
                    <Form.Group as={Col}>
                            <Form.Label>Quantification</Form.Label>
                            <Form.Control as={'select'} name={'quantification'}  onChange={this.handleQuantification} value={this.props.data['quantification']} disabled={this.props.edit? true: this.state.quantificationDisabled}>
                                <option></option>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group>
                        <Col>
                            <Form.Group>
                                <Form.Label>Right putamen</Form.Label>
                                <Form.Control type={"text"} name={'right_putamen'} onChange={(event)=>this.props.handler("datscan",event)} value={this.props.data['right_putamen']} disabled={this.props.edit? true: this.state.quantificationMoreDisabled}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Left putamen</Form.Label>
                                <Form.Control type={"text"} name={'left_putamen'} onChange={(event)=>this.props.handler("datscan",event)} value={this.props.data['left_putamen']} disabled={this.props.edit? true: this.state.quantificationMoreDisabled}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Right caudate nucleus</Form.Label>
                                <Form.Control type={"text"} name={'right_caudate_nucleus'} onChange={(event)=>this.props.handler("datscan",event)} value={this.props.data['right_caudate_nucleus']} disabled={this.props.edit? true: this.state.quantificationMoreDisabled}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Left caudate nucleus</Form.Label>
                                <Form.Control type={"text"} name={'left_caudate_nucleus'}onChange={(event)=>this.props.handler("datscan",event)}  value={this.props.data['left_caudate_nucleus']} disabled={this.props.edit? true: this.state.quantificationMoreDisabled}/>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Asymmetry index</Form.Label>
                                <Form.Control type={"text"} name={'asymmetry_index'}onChange={(event)=>this.props.handler("datscan",event)}  value={this.props.data['asymmetry_index']} disabled={this.props.edit? true: this.state.quantificationMoreDisabled}/>
                            </Form.Group>
                        </Col>
                    </Form.Row>
                </Form>
            </div>
        )
    }
}

export default Datscan